const numeral = require('numeral');

/* eslint-disable */
const IN_ST_SIGNED_UP = 1;
const IN_ST_EMAIL_VERIFIED = 2;
const IN_ST_KYC_UPLOADED = 4;
const IN_ST_KYC_APPROVED = 8;
const IN_ST_CORP_RESOLUTION_UPLOADED = 16;
const IN_ST_CORP_RESOLUTION_APPROVED = 32;
const IN_ST_TOS_ACCEPTED = 64;
const IN_ST_TRADING_ALLOWED = 128;
const IN_ST_KYC_DENIED = 256;
const IN_ST_MANAGER_RECOMMENDED = 512;
const IN_ST_KYC_SENTBACK = 1024;
const IN_ST_KYC_BACKGROUND_CHECK = 2048;
const IN_ST_TREASURY = 4096;
const IN_ST_TRADING_BLOCKED = 8192;
const IN_ST_CMS_KEYS = 16384;
const IN_ST_DORMANT = 268435456;

const FU_ST_RECEIVED = 1;
const FU_ST_NOTIFIED = 2;
const FU_ST_UNMATCHED = 4;
const FU_ST_AT_COMPLIANCE = 8;
const FU_ST_DEPOSITED = 16;
const FU_ST_PENDING = 32;
const FU_ST_CONFIRMING = 512;
const FU_ST_EXPIRED = 1024;
const FU_ST_DECLINED = 2048;
const FU_ST_CANCELED_BY_INVESTOR = 64;
const FU_ST_CANCELED_BY_ACCOUNTING_CLERK = 128;
const FU_ST_CONFIRMED = 256;

const W_RECEIVED = 1;
const W_REVIEWED = 2;
const W_DENIED = 3;
const W_CLOSED = 4;
const W_CANCELED = 5;

module.exports = {
    md5: function (s) {
        // eslint-disable-next-line
        function L(k, d) { return (k << d) | (k >>> (32 - d)) } function K(G, k) { var I, d, F, H, x; F = (G & 2147483648); H = (k & 2147483648); I = (G & 1073741824); d = (k & 1073741824); x = (G & 1073741823) + (k & 1073741823); if (I & d) { return (x ^ 2147483648 ^ F ^ H) } if (I | d) { if (x & 1073741824) { return (x ^ 3221225472 ^ F ^ H) } else { return (x ^ 1073741824 ^ F ^ H) } } else { return (x ^ F ^ H) } } function r(d, F, k) { return (d & F) | ((~d) & k) } function q(d, F, k) { return (d & k) | (F & (~k)) } function p(d, F, k) { return (d ^ F ^ k) } function n(d, F, k) { return (F ^ (d | (~k))) } function u(G, F, aa, Z, k, H, I) { G = K(G, K(K(r(F, aa, Z), k), I)); return K(L(G, H), F) } function f(G, F, aa, Z, k, H, I) { G = K(G, K(K(q(F, aa, Z), k), I)); return K(L(G, H), F) } function D(G, F, aa, Z, k, H, I) { G = K(G, K(K(p(F, aa, Z), k), I)); return K(L(G, H), F) } function t(G, F, aa, Z, k, H, I) { G = K(G, K(K(n(F, aa, Z), k), I)); return K(L(G, H), F) } function e(G) { var Z; var F = G.length; var x = F + 8; var k = (x - (x % 64)) / 64; var I = (k + 1) * 16; var aa = Array(I - 1); var d = 0; var H = 0; while (H < F) { Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = (aa[Z] | (G.charCodeAt(H) << d)); H++ } Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = aa[Z] | (128 << d); aa[I - 2] = F << 3; aa[I - 1] = F >>> 29; return aa } function B(x) { var k = "", F = "", G, d; for (d = 0; d <= 3; d++) { G = (x >>> (d * 8)) & 255; F = "0" + G.toString(16); k = k + F.substr(F.length - 2, 2) } return k } function J(k) { k = k.replace(/rn/g, "n"); var d = ""; for (var F = 0; F < k.length; F++) { var x = k.charCodeAt(F); if (x < 128) { d += String.fromCharCode(x) } else { if ((x > 127) && (x < 2048)) { d += String.fromCharCode((x >> 6) | 192); d += String.fromCharCode((x & 63) | 128) } else { d += String.fromCharCode((x >> 12) | 224); d += String.fromCharCode(((x >> 6) & 63) | 128); d += String.fromCharCode((x & 63) | 128) } } } return d } var C = Array(); var P, h, E, v, g, Y, X, W, V; var S = 7, Q = 12, N = 17, M = 22; var A = 5, z = 9, y = 14, w = 20; var o = 4, m = 11, l = 16, j = 23; var U = 6, T = 10, R = 15, O = 21; s = J(s); C = e(s); Y = 1732584193; X = 4023233417; W = 2562383102; V = 271733878; for (P = 0; P < C.length; P += 16) { h = Y; E = X; v = W; g = V; Y = u(Y, X, W, V, C[P + 0], S, 3614090360); V = u(V, Y, X, W, C[P + 1], Q, 3905402710); W = u(W, V, Y, X, C[P + 2], N, 606105819); X = u(X, W, V, Y, C[P + 3], M, 3250441966); Y = u(Y, X, W, V, C[P + 4], S, 4118548399); V = u(V, Y, X, W, C[P + 5], Q, 1200080426); W = u(W, V, Y, X, C[P + 6], N, 2821735955); X = u(X, W, V, Y, C[P + 7], M, 4249261313); Y = u(Y, X, W, V, C[P + 8], S, 1770035416); V = u(V, Y, X, W, C[P + 9], Q, 2336552879); W = u(W, V, Y, X, C[P + 10], N, 4294925233); X = u(X, W, V, Y, C[P + 11], M, 2304563134); Y = u(Y, X, W, V, C[P + 12], S, 1804603682); V = u(V, Y, X, W, C[P + 13], Q, 4254626195); W = u(W, V, Y, X, C[P + 14], N, 2792965006); X = u(X, W, V, Y, C[P + 15], M, 1236535329); Y = f(Y, X, W, V, C[P + 1], A, 4129170786); V = f(V, Y, X, W, C[P + 6], z, 3225465664); W = f(W, V, Y, X, C[P + 11], y, 643717713); X = f(X, W, V, Y, C[P + 0], w, 3921069994); Y = f(Y, X, W, V, C[P + 5], A, 3593408605); V = f(V, Y, X, W, C[P + 10], z, 38016083); W = f(W, V, Y, X, C[P + 15], y, 3634488961); X = f(X, W, V, Y, C[P + 4], w, 3889429448); Y = f(Y, X, W, V, C[P + 9], A, 568446438); V = f(V, Y, X, W, C[P + 14], z, 3275163606); W = f(W, V, Y, X, C[P + 3], y, 4107603335); X = f(X, W, V, Y, C[P + 8], w, 1163531501); Y = f(Y, X, W, V, C[P + 13], A, 2850285829); V = f(V, Y, X, W, C[P + 2], z, 4243563512); W = f(W, V, Y, X, C[P + 7], y, 1735328473); X = f(X, W, V, Y, C[P + 12], w, 2368359562); Y = D(Y, X, W, V, C[P + 5], o, 4294588738); V = D(V, Y, X, W, C[P + 8], m, 2272392833); W = D(W, V, Y, X, C[P + 11], l, 1839030562); X = D(X, W, V, Y, C[P + 14], j, 4259657740); Y = D(Y, X, W, V, C[P + 1], o, 2763975236); V = D(V, Y, X, W, C[P + 4], m, 1272893353); W = D(W, V, Y, X, C[P + 7], l, 4139469664); X = D(X, W, V, Y, C[P + 10], j, 3200236656); Y = D(Y, X, W, V, C[P + 13], o, 681279174); V = D(V, Y, X, W, C[P + 0], m, 3936430074); W = D(W, V, Y, X, C[P + 3], l, 3572445317); X = D(X, W, V, Y, C[P + 6], j, 76029189); Y = D(Y, X, W, V, C[P + 9], o, 3654602809); V = D(V, Y, X, W, C[P + 12], m, 3873151461); W = D(W, V, Y, X, C[P + 15], l, 530742520); X = D(X, W, V, Y, C[P + 2], j, 3299628645); Y = t(Y, X, W, V, C[P + 0], U, 4096336452); V = t(V, Y, X, W, C[P + 7], T, 1126891415); W = t(W, V, Y, X, C[P + 14], R, 2878612391); X = t(X, W, V, Y, C[P + 5], O, 4237533241); Y = t(Y, X, W, V, C[P + 12], U, 1700485571); V = t(V, Y, X, W, C[P + 3], T, 2399980690); W = t(W, V, Y, X, C[P + 10], R, 4293915773); X = t(X, W, V, Y, C[P + 1], O, 2240044497); Y = t(Y, X, W, V, C[P + 8], U, 1873313359); V = t(V, Y, X, W, C[P + 15], T, 4264355552); W = t(W, V, Y, X, C[P + 6], R, 2734768916); X = t(X, W, V, Y, C[P + 13], O, 1309151649); Y = t(Y, X, W, V, C[P + 4], U, 4149444226); V = t(V, Y, X, W, C[P + 11], T, 3174756917); W = t(W, V, Y, X, C[P + 2], R, 718787259); X = t(X, W, V, Y, C[P + 9], O, 3951481745); Y = K(Y, h); X = K(X, E); W = K(W, v); V = K(V, g) } var i = B(Y) + B(X) + B(W) + B(V); return i.toLowerCase()
    },
    addThousandCommas: function (nStr, overrideFormat) {
        const decimals = /\.0?0?[1-9]{1,3}/
        const threeDecimal = /\.\d{3}/
        var defaultFormat = overrideFormat || '0,0'

        if (decimals.test(nStr)) {
            if (threeDecimal.test(nStr)) {
                return numeral(nStr).format('0,0.000')
            }

            return numeral(nStr).format('0,0.00')
        }

        if (parseInt(nStr) < 10 ) {
            return numeral(nStr).format(overrideFormat || '0.00')
        }

        return numeral(nStr).format(defaultFormat)
    },

    addThousandCommasTwoDec: function (nStr, overrideFormat) {
        return numeral(nStr).format('0,0.00')
    },

    reduceByThousand: function (num) {
        var abbrev = ['', 'K', 'M', 'B', 'T', 'P', 'E'];
        if (num < 10000)
            return numeral(num).format('0,0')
        const unrangifiedOrder = Math.floor(Math.log10(Math.abs(num)) / 3);
        const order = Math.max(0, Math.min(unrangifiedOrder, abbrev.length - 1))
        const suffix = abbrev[order];

        return (num / Math.pow(10, order * 3)).toFixed(1) + suffix;
    },

    secondsToTime: function (secs) {
        var one_day = 60 * 60 * 24;    // Convert both dates to milliseconds
        var one_hour = 60 * 60;
        var one_min = 60;

        var returnVal = {
            remainX: 0,
            unit: 'day(s)'
        };

        if (secs >= one_day) {
            returnVal.remainX = Math.round(secs / one_day);
        }
        else if (secs >= one_hour) {
            returnVal.remainX = Math.round(secs / one_hour);
            returnVal.unit = 'hour(s)';
        }
        else if (secs >= one_min) {
            returnVal.remainX = Math.round(secs / one_min);
            returnVal.unit = 'min(s)';
        }
        else {
            returnVal.remainX = Math.floor(secs);
            returnVal.unit = 'seconds';
        }

        return returnVal;
    },
    validateEmail: function validateEmail(email) {
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    createCookie: function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    readCookie: function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    eraseCookie: function (name) {
        this.createCookie(name, "", -1);
    },

    daysUntil: function (start, end) {

        var difference_ms = end - start;        // Convert back to days and return

        return difference_ms / 1000;
    },

    isAdmin: function (account) {
        if (account._account_type === 'G') {
            return true;
        } else {
            return false;
        }
    },

    hash: function (loc) {
        if (window.history.pushState) {
            window.history.pushState(null, null, loc);
        }
        else {
            window.location.hash = loc;
        }
    },

    isEmpty: function (str) {
        return (!str || 0 === str.length);
    },

    getparams: function () {
        var regex = /[?&]([^=#]+)=([^&#]*)/g,
            url = window.location.href,
            params = {},
            match;
        while (match === regex.exec(url)) {
            params[match[1]] = match[2];
        }

        return params;
    },

    isJSON: function (item) {
        item = typeof item !== "string"
          ? JSON.stringify(item)
          : item;

        try {
            item = JSON.parse(item);
        } catch (e) {
            return false;
        }

        if (typeof item === "object" && item !== null) {
            return true;
        }

        return false;
    },

    changeCurrencyFormat: function (price, format = '0,000.00') {
        return '$' + this.addThousandCommas(price, format);
    },

    getCurrency: function (currency) {
        if (currency === 'EUR') {
            return {
                currency: 'EUR',
                currency_symbol: '€',
                currency_selector: 'eur'
            }
        } else if (currency === 'GBP') {
            return {
                currency: 'GBP',
                currency_symbol: '£',
                currency_selector: 'gbp'
            };
        } else if (currency === 'IPO') {
            return {
                currency: 'IPO',
                currency_symbol: '$̶',
                currency_selector: 'ipo'
            };
        } else if (currency === 'CHF') {
            return {
                currency: 'CHF',
                currency_symbol: 'CFH',
                currency_selector: 'chf'
            }
        } else if (currency === 'ANG') {
            return {
                currency: 'XCG',
                currency_symbol: 'Cg',
                currency_selector: 'xcg'
            }
        } else if (currency === 'XCG') {
            return {
                currency: 'XCG',
                currency_symbol: 'Cg',
                currency_selector: 'xcg'
            }
        } else {
            return {
                currency: 'USD',
                currency_symbol: '$',
                currency_selector: 'usd'
            };
        }
    },

    returnState: function (state){
        if(state & IN_ST_DORMANT){
            return ['dormant', 'Dormant'];
        }

        if(state & IN_ST_TRADING_BLOCKED){
            return ['blocked', 'Blocked'];
        }

        if(state & IN_ST_TRADING_ALLOWED){
            return ['allowed', 'Trading Allowed'];
        }

        if(state & IN_ST_KYC_DENIED){
            return ['denied', 'Denied'];
        }

        if(state & IN_ST_KYC_SENTBACK){
            return ['returned', 'KYC Returned'];
        }

        if(state & IN_ST_KYC_APPROVED){
            return ['approved', 'KYC Approved'];
        }

        if(state & IN_ST_KYC_UPLOADED){
            return ['uploaded', 'Documents Uploaded'];
        }

        if(state & IN_ST_EMAIL_VERIFIED){
            return ['verified', 'Email Verified'];
        }

        return ['signedup', 'Signed Up'];
    },

    returnDepositState: function (state){
        if(state & FU_ST_CANCELED_BY_INVESTOR){
            return ['cancelled', 'Cancelled'];
        }

        if(state & FU_ST_CANCELED_BY_ACCOUNTING_CLERK){
            return ['cancelled', 'Cancelled'];
        }

        if(state & FU_ST_DECLINED){
            return ['declined', 'Declined'];
        }

        if(state & FU_ST_EXPIRED){
            return ['expired', 'Expired'];
        }

        if(state & FU_ST_CONFIRMED){
            return ['confirmed', 'Confirmed'];
        }

        if(state & FU_ST_RECEIVED){
            return ['received', 'Received'];
        }
        if(state & FU_ST_NOTIFIED){
            return ['notified', 'Notified'];
        }

        return ['declined', 'Declined'];
    },

    returnWithdrawalState: function (state){
        if(state === W_RECEIVED){
            return ['received', 'Received'];
        }

        if(state === W_REVIEWED){
            return ['reviewed', 'Reviewed'];
        }

        if(state === W_DENIED){
            return ['denied', 'Denied'];
        }

        if(state === W_CLOSED){
            return ['complete', 'Complete'];
        }

        if(state === W_CANCELED){
            return ['cancelled', 'Cancelled By Broker'];
        }

        return ['received', 'Received'];
    },

    password: function(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
};
